import styled from "styled-components";

export const ContainerSubirOrden = styled.div`
  padding: 0 14px;
`;

export const Paso2Body = styled.div`
  .ValidaTurno-bodytxt {
    text-align: center;
  }
  .ValidaTurno-input {
    width: 190px;
  }

  .container-texto-promocional {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  img {
    width: 100%;
    height: 200px;
    object-fit: contain;
  }

  .container-spinnerEstadoOrden {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    height: 100%;
    width: 100%;
    padding-top: 50px;
    margin-bottom: 10px;
  }
  @media (max-height: 768px) {
    overflow-y: hidden;
    overflow-x: hidden;
    height: 519px;
    ::-webkit-scrollbar {
      width: 10px;
    }
    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: var(--color-scrollbar);
    }
  }
`;
